import { createSSRApp } from "vue";
import { createPinia } from "pinia";
import App from "./App.vue";
import AIChatBar from "@/components/AIChatBar.vue";

import "@/utils/request-interceptor";
import "ant-design-vue/lib/message/style/index.css";
import "virtual:svg-icons-register";
import "virtual:windi.css";
import "vant/es/dialog/style";
import "vant/es/search/style";
import "vant/es/switch/style";
import "vant/es/tabs/style";
import "vant/es/tab/style";
import "vant/es/image-preview/style";

const pinia = createPinia();

export function createApp() {
  const app = createSSRApp(App);
  // app.use(VueViewer)
  app.use(pinia);

  // AI 助手初始化（仅在 H5 环境）
  // #ifdef H5
  try {
    const aiRootId = 'ai-chat-root';
    if (!document.getElementById(aiRootId)) {
      const div = document.createElement('div');
      div.id = aiRootId;
      document.body.appendChild(div);
      const aiApp = createSSRApp(AIChatBar);
      aiApp.mount(div);
    }
  } catch (error) {
    console.error("Failed to mount AI Chat Bar", error);
  }
  // #endif

  return {
    app,
  };
}
